module.exports = __webpack_public_path__ + "img/icon-attachment.a7dc8899.svg";